import React, { useState, useEffect, useCallback } from "react";

const API = "https://canada-billing.ameontech.com";

const MONTH_NAMES = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

// ============================================================
// STYLES — matches Dashboard.js design system (ic- variables)
// ============================================================
const Styles = () => (
  <style>{`
    .pd-wrap { font-family: 'DM Sans', system-ui, sans-serif; }

    .pd-toolbar {
      display: flex; align-items: center; justify-content: space-between;
      gap: 12px; margin-bottom: 18px; flex-wrap: wrap;
    }
    .pd-search {
      flex: 1; min-width: 220px; position: relative;
    }
    .pd-search input {
      width: 100%; padding: 9px 14px 9px 34px; border: 1px solid var(--border, #eee);
      border-radius: 10px; font-size: 13px; font-family: inherit; outline: none;
      background: #fff; transition: border-color .15s;
    }
    .pd-search input:focus { border-color: var(--blue, #4f8ef7); }
    .pd-search-icon { position: absolute; left: 12px; top: 50%; transform: translateY(-50%); font-size: 13px; color: #aaa; }

    .pd-btn {
      display: inline-flex; align-items: center; gap: 6px; padding: 9px 16px;
      border-radius: 10px; font-size: 13px; font-weight: 600; border: none;
      cursor: pointer; font-family: inherit; transition: all .15s; white-space: nowrap;
    }
    .pd-btn-primary { background: var(--blue, #4f8ef7); color: #fff; }
    .pd-btn-primary:hover { background: #3f7de6; }
    .pd-btn-ghost { background: #fff; color: #555; border: 1px solid #e5e5e5; }
    .pd-btn-ghost:hover { border-color: #ccc; }
    .pd-btn-sm { padding: 5px 10px; font-size: 11.5px; border-radius: 7px; }

    .pd-stats { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; margin-bottom: 18px; }
    .pd-stat {
      background: #fff; border: 1px solid #f0f0f0; border-radius: 12px; padding: 14px 16px;
    }
    .pd-stat-label { font-size: 11px; color: #999; font-weight: 600; text-transform: uppercase; letter-spacing: .4px; }
    .pd-stat-value { font-family: 'Playfair Display', serif; font-size: 22px; font-weight: 700; color: #1a1a2e; margin-top: 4px; }
    .pd-stat-value.warn { color: #f97b6b; }

    .pd-table-card {
      background: #fff; border: 1px solid #f0f0f0; border-radius: 14px; overflow: hidden;
    }
    table.pd-table { width: 100%; border-collapse: collapse; font-size: 13px; }
    .pd-table thead tr { background: #fafafb; border-bottom: 1px solid #f0f0f0; }
    .pd-table th {
      text-align: left; padding: 11px 14px; font-size: 10.5px; font-weight: 700;
      color: #999; text-transform: uppercase; letter-spacing: .5px;
    }
    .pd-table td { padding: 12px 14px; border-bottom: 1px solid #f6f6f6; color: #333; vertical-align: middle; }
    .pd-table tr:last-child td { border-bottom: none; }
    .pd-table tr:hover td { background: #fafcff; }

    .pd-pname { font-weight: 600; color: #1a1a2e; }
    .pd-pbrand { font-size: 11.5px; color: #999; margin-top: 1px; }

    .pd-qty-badge {
      display: inline-flex; align-items: center; gap: 5px; padding: 3px 10px;
      border-radius: 20px; font-size: 12px; font-weight: 700;
    }
    .pd-qty-ok { background: #eafaf0; color: #1d9a5b; }
    .pd-qty-low { background: #fff0ee; color: #e0503e; }

    .pd-row-actions { display: flex; gap: 6px; flex-wrap: wrap; }

    .pd-empty { padding: 60px 20px; text-align: center; color: #aaa; }
    .pd-empty-icon { font-size: 34px; opacity: .3; margin-bottom: 8px; }

    /* Modal */
    .pd-overlay {
      position: fixed; inset: 0; background: rgba(15,15,25,.45); z-index: 999;
      display: flex; align-items: center; justify-content: center; padding: 20px;
    }
    .pd-modal {
      background: #fff; border-radius: 16px; width: min(480px, 100%);
      max-height: 90vh; overflow-y: auto; box-shadow: 0 30px 70px rgba(0,0,0,.25);
    }
    .pd-modal-head {
      padding: 20px 22px 16px; border-bottom: 1px solid #f0f0f0;
      display: flex; justify-content: space-between; align-items: center;
    }
    .pd-modal-title { font-family: 'Playfair Display', serif; font-size: 17px; font-weight: 700; color: #1a1a2e; }
    .pd-modal-close {
      width: 28px; height: 28px; border-radius: 50%; border: none; background: #f3f3f5;
      cursor: pointer; font-size: 15px; color: #777;
    }
    .pd-modal-body { padding: 20px 22px; display: flex; flex-direction: column; gap: 13px; }
    .pd-field-label { font-size: 12px; color: #777; font-weight: 500; margin-bottom: 5px; }
    .pd-input, .pd-select {
      width: 100%; padding: 9px 12px; border: 1px solid #e5e5e5; border-radius: 8px;
      font-size: 13px; font-family: inherit; outline: none; box-sizing: border-box;
    }
    .pd-input:focus, .pd-select:focus { border-color: var(--blue, #4f8ef7); }
    .pd-grid2 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
    .pd-modal-foot {
      padding: 16px 22px; border-top: 1px solid #f0f0f0; display: flex; justify-content: flex-end; gap: 10px;
    }
    .pd-error { background: #fff1f0; border: 1px solid #ffd6d2; color: #d0392a; padding: 9px 12px; border-radius: 8px; font-size: 12.5px; }
    .pd-success { background: #eafaf0; border: 1px solid #b9edcd; color: #1d9a5b; padding: 9px 12px; border-radius: 8px; font-size: 12.5px; }

    .pd-stockmodal-qty { display: flex; align-items: center; gap: 10px; }
    .pd-stockmodal-qty input { width: 100px; text-align: center; font-size: 16px; font-weight: 700; }

    /* Monthly history modal */
    .pd-history-stats { display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px; margin-bottom: 4px; }
    .pd-history-stat { background: #fff; border: 1px solid #f0f0f0; border-radius: 12px; padding: 10px 12px; }
  `}</style>
);

// ============================================================
// HELPERS
// ============================================================
const getToken = () =>
  (typeof localStorage !== "undefined" && localStorage.getItem("token")) || null;

const authHeaders = () => {
  const t = getToken();
  return t ? { "Content-Type": "application/json", Authorization: `Bearer ${t}` } : null;
};

const emptyForm = () => ({
  product_name: "", brand: "", sku: "", category: "", description: "",
  purchase_price: "", selling_price: "", quantity: "", unit: "pcs", low_stock_alert: "5",
});

// ============================================================
// STOCK MOVEMENT MODAL (shared for IN / OUT)
// ============================================================
function StockModal({ product, mode, onClose, onDone }) {
  const [qty, setQty] = useState("");
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const isIn = mode === "in";

  const submit = async () => {
    const headers = authHeaders();
    const q = parseInt(qty, 10);
    if (!headers) { setError("Please log in first."); return; }
    if (!q || q <= 0) { setError("Enter a valid quantity."); return; }
    setSaving(true); setError("");
    try {
      const res = await fetch(`${API}/api/products/${product.id}/stock-${mode}`, {
        method: "POST", headers,
        body: JSON.stringify({ quantity: q, reason: reason || undefined }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.message || "Failed to update stock."); return; }
      onDone(data.product);
    } catch (err) {
      setError(`Network error: ${err.message}`);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="pd-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="pd-modal" style={{ width: 380 }}>
        <div className="pd-modal-head">
          <div className="pd-modal-title">{isIn ? "📦 Add Stock" : "📤 Remove Stock"}</div>
          <button className="pd-modal-close" onClick={onClose}>×</button>
        </div>
        <div className="pd-modal-body">
          <div style={{ fontSize: 13, color: "#666" }}>
            <strong style={{ color: "#1a1a2e" }}>{product.product_name}</strong> — current stock:{" "}
            <strong>{product.quantity} {product.unit}</strong>
          </div>
          {error && <div className="pd-error">⚠️ {error}</div>}
          <div>
            <div className="pd-field-label">{isIn ? "Quantity received" : "Quantity sold / removed"}</div>
            <div className="pd-stockmodal-qty">
              <input
                className="pd-input" type="number" min="1" autoFocus
                value={qty} onChange={(e) => setQty(e.target.value)} placeholder="0"
              />
              <span style={{ fontSize: 13, color: "#888" }}>{product.unit}</span>
            </div>
          </div>
          <div>
            <div className="pd-field-label">Reason / note (optional)</div>
            <input
              className="pd-input" value={reason} onChange={(e) => setReason(e.target.value)}
              placeholder={isIn ? "e.g. New shipment received" : "e.g. Sold to walk-in customer"}
            />
          </div>
        </div>
        <div className="pd-modal-foot">
          <button className="pd-btn pd-btn-ghost" onClick={onClose}>Cancel</button>
          <button
            className="pd-btn pd-btn-primary" onClick={submit} disabled={saving}
            style={{ background: isIn ? "#1d9a5b" : "#e0503e" }}
          >
            {saving ? "Saving..." : isIn ? "Add Stock" : "Remove Stock"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ============================================================
// ADD / EDIT PRODUCT MODAL
// ============================================================
function ProductFormModal({ product, onClose, onSaved }) {
  const isEdit = !!product;
  const [form, setForm] = useState(() =>
    product
      ? {
          product_name: product.product_name || "",
          brand: product.brand || "",
          sku: product.sku || "",
          category: product.category || "",
          description: product.description || "",
          purchase_price: product.purchase_price ?? "",
          selling_price: product.selling_price ?? "",
          quantity: product.quantity ?? "",
          unit: product.unit || "pcs",
          low_stock_alert: product.low_stock_alert ?? "5",
        }
      : emptyForm()
  );
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const set = (key) => (e) => setForm((p) => ({ ...p, [key]: e.target.value }));

  const submit = async () => {
    const headers = authHeaders();
    if (!headers) { setError("Please log in first."); return; }
    if (!form.product_name.trim()) { setError("Product name is required."); return; }
    setSaving(true); setError("");
    try {
      const url = isEdit ? `${API}/api/products/${product.id}` : `${API}/api/products`;
      const method = isEdit ? "PUT" : "POST";
      const res = await fetch(url, { method, headers, body: JSON.stringify(form) });
      const data = await res.json();
      if (!res.ok) { setError(data.message || "Failed to save product."); return; }
      onSaved(data.product);
    } catch (err) {
      setError(`Network error: ${err.message}`);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="pd-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="pd-modal">
        <div className="pd-modal-head">
          <div className="pd-modal-title">{isEdit ? "✏️ Edit Product" : "➕ Add Product"}</div>
          <button className="pd-modal-close" onClick={onClose}>×</button>
        </div>
        <div className="pd-modal-body">
          {error && <div className="pd-error">⚠️ {error}</div>}

          <div>
            <div className="pd-field-label">Product name *</div>
            <input className="pd-input" value={form.product_name} onChange={set("product_name")} placeholder="e.g. Vivo Y200" />
          </div>

          <div className="pd-grid2">
            <div>
              <div className="pd-field-label">Brand</div>
              <input className="pd-input" value={form.brand} onChange={set("brand")} placeholder="e.g. Vivo" />
            </div>
            <div>
              <div className="pd-field-label">SKU / Code</div>
              <input className="pd-input" value={form.sku} onChange={set("sku")} placeholder="Optional" />
            </div>
          </div>

          <div>
            <div className="pd-field-label">Category</div>
            <input className="pd-input" value={form.category} onChange={set("category")} placeholder="e.g. Electronics" />
          </div>

          <div className="pd-grid2">
            <div>
              <div className="pd-field-label">Purchase price (CA$)</div>
              <input className="pd-input" type="number" min="0" value={form.purchase_price} onChange={set("purchase_price")} placeholder="0.00" />
            </div>
            <div>
              <div className="pd-field-label">Selling price (CA$)</div>
              <input className="pd-input" type="number" min="0" value={form.selling_price} onChange={set("selling_price")} placeholder="0.00" />
            </div>
          </div>

          <div className="pd-grid2">
            <div>
              <div className="pd-field-label">{isEdit ? "Current stock" : "Opening stock"}</div>
              <input
                className="pd-input" type="number" min="0" value={form.quantity}
                onChange={set("quantity")} placeholder="0" disabled={isEdit}
                style={isEdit ? { background: "#f6f6f6", cursor: "not-allowed" } : {}}
              />
              {isEdit && (
                <div style={{ fontSize: 11, color: "#999", marginTop: 4 }}>
                  Use "Add / Remove Stock" buttons to change quantity
                </div>
              )}
            </div>
            <div>
              <div className="pd-field-label">Unit</div>
              <select className="pd-select" value={form.unit} onChange={set("unit")}>
                <option value="pcs">pcs</option>
                <option value="box">box</option>
                <option value="kg">kg</option>
                <option value="litre">litre</option>
                <option value="set">set</option>
              </select>
            </div>
          </div>

          <div>
            <div className="pd-field-label">Low stock alert threshold</div>
            <input className="pd-input" type="number" min="0" value={form.low_stock_alert} onChange={set("low_stock_alert")} />
          </div>
        </div>
        <div className="pd-modal-foot">
          <button className="pd-btn pd-btn-ghost" onClick={onClose}>Cancel</button>
          <button className="pd-btn pd-btn-primary" onClick={submit} disabled={saving}>
            {saving ? "Saving..." : isEdit ? "Save Changes" : "Add Product"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ============================================================
// MONTHLY STOCK HISTORY MODAL (NEW)
// Uses GET /api/products/:id/monthly-summary?month=&year=
// ============================================================
function ProductHistoryModal({ product, onClose }) {
  const now = new Date();
  const [month, setMonth] = useState(now.getMonth() + 1);
  const [year, setYear] = useState(now.getFullYear());
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const years = [];
  for (let y = now.getFullYear(); y >= now.getFullYear() - 4; y--) years.push(y);

  const load = useCallback(async (m, y) => {
    const headers = authHeaders();
    if (!headers) { setError("Please log in first."); setLoading(false); return; }
    setLoading(true); setError("");
    try {
      const res = await fetch(
        `${API}/api/products/${product.id}/monthly-summary?month=${m}&year=${y}`,
        { headers }
      );
      const json = await res.json();
      if (!res.ok) { setError(json.message || "Failed to load history."); return; }
      setData(json);
    } catch (err) {
      setError(`Network error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  }, [product.id]);

  useEffect(() => { load(month, year); }, [month, year, load]);

  return (
    <div className="pd-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="pd-modal" style={{ width: 560 }}>
        <div className="pd-modal-head">
          <div className="pd-modal-title">📊 {product.product_name} — Stock History</div>
          <button className="pd-modal-close" onClick={onClose}>×</button>
        </div>
        <div className="pd-modal-body">
          <div style={{ display: "flex", gap: 8 }}>
            <select
              className="pd-select" style={{ width: 150 }}
              value={month} onChange={(e) => setMonth(parseInt(e.target.value))}
            >
              {MONTH_NAMES.map((m, i) => <option key={i} value={i + 1}>{m}</option>)}
            </select>
            <select
              className="pd-select" style={{ width: 100 }}
              value={year} onChange={(e) => setYear(parseInt(e.target.value))}
            >
              {years.map((y) => <option key={y} value={y}>{y}</option>)}
            </select>
          </div>

          {error && <div className="pd-error">⚠️ {error}</div>}

          {loading ? (
            <div style={{ padding: 30, textAlign: "center", color: "#999" }}>Loading...</div>
          ) : data ? (
            <>
              <div className="pd-history-stats">
                <div className="pd-history-stat">
                  <div className="pd-stat-label">Opening</div>
                  <div className="pd-stat-value" style={{ fontSize: 17 }}>
                    {data.opening_stock} {data.product.unit}
                  </div>
                </div>
                <div className="pd-history-stat">
                  <div className="pd-stat-label">Restocked</div>
                  <div className="pd-stat-value" style={{ fontSize: 17, color: "#1d9a5b" }}>
                    +{data.total_restocked} ({data.restock_count}x)
                  </div>
                </div>
                <div className="pd-history-stat">
                  <div className="pd-stat-label">Sold / Removed</div>
                  <div className="pd-stat-value" style={{ fontSize: 17, color: "#e0503e" }}>
                    -{data.total_sold_or_removed} ({data.sale_count}x)
                  </div>
                </div>
                <div className="pd-history-stat">
                  <div className="pd-stat-label">Closing</div>
                  <div className="pd-stat-value" style={{ fontSize: 17 }}>
                    {data.closing_stock} {data.product.unit}
                  </div>
                </div>
              </div>

              <div className="pd-field-label" style={{ marginTop: 8 }}>Day-by-day movement</div>
              {data.daily.length === 0 ? (
                <div style={{ fontSize: 12.5, color: "#999", padding: "10px 0" }}>
                  No stock movement recorded for {MONTH_NAMES[month - 1]} {year}.
                </div>
              ) : (
                <div style={{ maxHeight: 220, overflowY: "auto", border: "1px solid #f0f0f0", borderRadius: 10 }}>
                  <table className="pd-table">
                    <thead>
                      <tr><th>Date</th><th>Restocked (IN)</th><th>Sold / Removed (OUT)</th></tr>
                    </thead>
                    <tbody>
                      {data.daily.map((d) => (
                        <tr key={d.day}>
                          <td>{new Date(d.day).toLocaleDateString("en-CA")}</td>
                          <td style={{ color: d.stock_in > 0 ? "#1d9a5b" : "#ccc" }}>
                            {d.stock_in > 0 ? `+${d.stock_in}` : "—"}
                          </td>
                          <td style={{ color: d.stock_out > 0 ? "#e0503e" : "#ccc" }}>
                            {d.stock_out > 0 ? `-${d.stock_out}` : "—"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </>
          ) : null}
        </div>
        <div className="pd-modal-foot">
          <button className="pd-btn pd-btn-ghost" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}

// ============================================================
// MAIN COMPONENT
// ============================================================
export default function ProductManagement() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [editProduct, setEditProduct] = useState(null);
  const [stockModal, setStockModal] = useState(null); // { product, mode: 'in'|'out' }
  const [historyProduct, setHistoryProduct] = useState(null); // NEW: product for history modal
  const [successMsg, setSuccessMsg] = useState("");

  const fetchProducts = useCallback(async () => {
    const headers = authHeaders();
    if (!headers) { setError("Please log in to view products."); setLoading(false); return; }
    setLoading(true); setError("");
    try {
      const res = await fetch(`${API}/api/products`, { headers });
      const data = await res.json();
      if (!res.ok) { setError(data.message || "Failed to load products."); return; }
      setProducts(data.products || []);
    } catch (err) {
      setError(`Network error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchProducts(); }, [fetchProducts]);

  const flashSuccess = (msg) => {
    setSuccessMsg(msg);
    setTimeout(() => setSuccessMsg(""), 2500);
  };

  const handleDelete = async (product) => {
    if (!window.confirm(`Delete "${product.product_name}"? This cannot be undone.`)) return;
    const headers = authHeaders();
    try {
      const res = await fetch(`${API}/api/products/${product.id}`, { method: "DELETE", headers });
      const data = await res.json();
      if (!res.ok) { setError(data.message || "Failed to delete."); return; }
      setProducts((prev) => prev.filter((p) => p.id !== product.id));
      flashSuccess("Product deleted.");
    } catch (err) {
      setError(`Network error: ${err.message}`);
    }
  };

  const filtered = products.filter((p) => {
    if (!search) return true;
    const q = search.toLowerCase();
    return (
      p.product_name?.toLowerCase().includes(q) ||
      p.brand?.toLowerCase().includes(q) ||
      p.sku?.toLowerCase().includes(q) ||
      p.category?.toLowerCase().includes(q)
    );
  });

  const totalProducts = products.length;
  const totalStockUnits = products.reduce((s, p) => s + (parseInt(p.quantity) || 0), 0);
  const lowStockCount = products.filter((p) => p.quantity <= p.low_stock_alert).length;
  const inventoryValue = products.reduce(
    (s, p) => s + (parseFloat(p.selling_price) || 0) * (parseInt(p.quantity) || 0), 0
  );

  return (
    <div className="pd-wrap">
      <Styles />

      {error && <div className="pd-error" style={{ marginBottom: 14 }}>⚠️ {error}</div>}
      {successMsg && <div className="pd-success" style={{ marginBottom: 14 }}>✓ {successMsg}</div>}

      <div className="pd-stats">
        <div className="pd-stat">
          <div className="pd-stat-label">Total Products</div>
          <div className="pd-stat-value">{totalProducts}</div>
        </div>
        <div className="pd-stat">
          <div className="pd-stat-label">Total Stock Units</div>
          <div className="pd-stat-value">{totalStockUnits}</div>
        </div>
        <div className="pd-stat">
          <div className="pd-stat-label">Low Stock Items</div>
          <div className={`pd-stat-value ${lowStockCount > 0 ? "warn" : ""}`}>{lowStockCount}</div>
        </div>
        <div className="pd-stat">
          <div className="pd-stat-label">Inventory Value</div>
          <div className="pd-stat-value">
            CA$ {inventoryValue.toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </div>
        </div>
      </div>

      <div className="pd-toolbar">
        <div className="pd-search">
          <span className="pd-search-icon">🔍</span>
          <input
            placeholder="Search by name, brand, SKU, category..."
            value={search} onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <button className="pd-btn pd-btn-primary" onClick={() => { setEditProduct(null); setShowForm(true); }}>
          ➕ Add Product
        </button>
      </div>

      <div className="pd-table-card">
        {loading ? (
          <div className="pd-empty">Loading products...</div>
        ) : filtered.length === 0 ? (
          <div className="pd-empty">
            <div className="pd-empty-icon">📦</div>
            <div style={{ fontWeight: 600, color: "#666", marginBottom: 4 }}>
              {search ? "No products match your search" : "No products yet"}
            </div>
            <div style={{ fontSize: 12.5 }}>
              {search ? "Try a different search term." : 'Click "Add Product" to create your first one.'}
            </div>
          </div>
        ) : (
          <table className="pd-table">
            <thead>
              <tr>
                <th>Product</th>
                <th>Category</th>
                <th>Price</th>
                <th>Stock</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((p) => {
                const low = parseInt(p.quantity) <= parseInt(p.low_stock_alert);
                return (
                  <tr key={p.id}>
                    <td>
                      <div className="pd-pname">{p.product_name}</div>
                      {(p.brand || p.sku) && (
                        <div className="pd-pbrand">
                          {p.brand}{p.brand && p.sku ? " · " : ""}{p.sku}
                        </div>
                      )}
                    </td>
                    <td>{p.category || "—"}</td>
                    <td>
                      CA$ {parseFloat(p.selling_price || 0).toLocaleString("en-CA", { minimumFractionDigits: 2 })}
                    </td>
                    <td>
                      <span className={`pd-qty-badge ${low ? "pd-qty-low" : "pd-qty-ok"}`}>
                        {low && "⚠ "}{p.quantity} {p.unit}
                      </span>
                    </td>
                    <td>
                      <div className="pd-row-actions">
                        <button
                          className="pd-btn pd-btn-ghost pd-btn-sm"
                          style={{ color: "#1d9a5b", borderColor: "#b9edcd" }}
                          onClick={() => setStockModal({ product: p, mode: "in" })}
                        >
                          + Stock
                        </button>
                        <button
                          className="pd-btn pd-btn-ghost pd-btn-sm"
                          style={{ color: "#e0503e", borderColor: "#ffd6d2" }}
                          onClick={() => setStockModal({ product: p, mode: "out" })}
                        >
                          − Stock
                        </button>
                        <button
                          className="pd-btn pd-btn-ghost pd-btn-sm"
                          style={{ color: "#4f8ef7", borderColor: "#cfe0fb" }}
                          onClick={() => setHistoryProduct(p)}
                        >
                          📊 History
                        </button>
                        <button
                          className="pd-btn pd-btn-ghost pd-btn-sm"
                          onClick={() => { setEditProduct(p); setShowForm(true); }}
                        >
                          Edit
                        </button>
                        <button
                          className="pd-btn pd-btn-ghost pd-btn-sm"
                          style={{ color: "#e0503e" }}
                          onClick={() => handleDelete(p)}
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      {showForm && (
        <ProductFormModal
          product={editProduct}
          onClose={() => setShowForm(false)}
          onSaved={(saved) => {
            setShowForm(false);
            setProducts((prev) => {
              const exists = prev.some((p) => p.id === saved.id);
              return exists ? prev.map((p) => (p.id === saved.id ? saved : p)) : [saved, ...prev];
            });
            flashSuccess(editProduct ? "Product updated." : "Product added.");
          }}
        />
      )}

      {stockModal && (
        <StockModal
          product={stockModal.product}
          mode={stockModal.mode}
          onClose={() => setStockModal(null)}
          onDone={(updated) => {
            setStockModal(null);
            setProducts((prev) => prev.map((p) => (p.id === updated.id ? updated : p)));
            flashSuccess(stockModal.mode === "in" ? "Stock added." : "Stock removed.");
          }}
        />
      )}

      {historyProduct && (
        <ProductHistoryModal
          product={historyProduct}
          onClose={() => setHistoryProduct(null)}
        />
      )}
    </div>
  );
}